import {
  PlusOutlined
} from '@ant-design/icons';
import { Button, Col, Row, Tabs } from 'antd';
import { getCookie, setCookie } from 'helper/cookie';
import emptyState from 'icons/createproject/emptyStatePL.svg';
import lang from 'lang/en';
import { useContext, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import 'styleLess/signature/projectlist.scss';
import { REACT_APP_URL } from '../../config/env';
import CardListComponents from './components/card.components';
import HeaderContent from './components/headerContent.components';
//checkrole
import { CounterContext } from 'redux/Golbalvalues';
import Iframe from './components/Iframe.components';
const { TabPane } = Tabs
const Container = styled.div``
const EmptyContainer = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}
const HomeComponents = () => {
  const [dataSearch, setDataSearch] = useState('')
  const [render, setRender] = useState(1)
  const [activeTabKey, setActiveTabKey] = useState(
    localStorage.getItem('activeProjectTab') || '1',
  )
  const history = useHistory()
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const company_user = getCookie('ProfessSK_comID')
  const word = lang[language]
  const [receivedData, setReceivedData] = useState('')
  const [permission, setPermission] = useState({
    menu_id: 0,
    create: false,
    read: false,
    update: false,
    delete: false,
  })
  const ganttRef = useRef(null)
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement)
    }
    document.addEventListener('fullscreenchange', onFullscreenChange)
    document.addEventListener('webkitfullscreenchange', onFullscreenChange)
    document.addEventListener('mozfullscreenchange', onFullscreenChange)
    document.addEventListener('MSFullscreenChange', onFullscreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', onFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', onFullscreenChange)
      document.removeEventListener('mozfullscreenchange', onFullscreenChange)
      document.removeEventListener('MSFullscreenChange', onFullscreenChange)
    }
  }, [])

  let roleUser = parseInt(getCookie('roleUser'))

  //check role
  const { adminPermission } = useContext(CounterContext)
  useEffect(() => {
    adminPermission?.map((item) => {
      if (roleUser === 1) {
        setPermission((prevState) => ({
          ...prevState,
          create: true,
          read: true,
          update: true,
          delete: true,
        }))
      } else {
        if (item?.menu_id === 2 || item?.menu_id === 3 || item?.menu_id === 25) {
          setPermission((prevState) => ({
            ...prevState,
            menu_id: item?.menu_id,
            create: item?.create == 'Y' ? true : false,
            read: item?.create == 'Y' ? true : false,
            update: item?.update == 'Y' ? true : false,
            delete: item?.delete == 'Y' ? true : false,
          }))
        }
      }
    })
  }, [adminPermission])

  // gantt update task inbox
  useEffect(() => {
    const openUrlFromExternal = (event) => {
      if (event.origin !== `${REACT_APP_URL}`) return;
      if (event.data.action === "openTaskInbox") {
        window.open(
          `${REACT_APP_URL}/taskinbox/${event.data.project_id}/${event.data.task_id}/update/`,
          "_blank"
        );
      }
      if (event.data.action === "openProjectQuickUpdate") {
        window.open(
          `${REACT_APP_URL}/project/${event.data.project_id}/quick-update/`,
          "_self"
        );
      }
      if (event.data.action === "openHelpdeskInApp") {
        window.open(
          `${REACT_APP_URL}/helpdesk`,
          "_self"
        );
      }
    };
    window.addEventListener("message", openUrlFromExternal);
    return () => window.removeEventListener("message", openUrlFromExternal);
  }, []);

  const goCreate = () => {
    setCookie('wordLine', '')
    localStorage.setItem('activeProjectTab', '2')
    history.push({
      pathname: '/create-project',
    })
  }

  const showContent = () => {
    if (render === 1) {
      return (
        <Container className="container-component">
          <div>
            <CardListComponents
              receivedData={receivedData}
              dataSearch={dataSearch}
              permission={permission}
              roleUser={roleUser}
              word={word}
            />
          </div>
        </Container>
      )
    } else {
      // empty state
      return (
        <Container className="container-component">
          <Helmet>
            <title> AXONS PROJECT | {word['Project_List']} </title>
          </Helmet>
          <Row
            className="flex-position"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Col>
              <div style={{ marginBottom: '24px' }} className="no-breadcrumb">
                {word['Project']}
              </div>
            </Col>
          </Row>
          <EmptyContainer className="empty-container">
            <img className="img-emptystate" src={emptyState}></img>
            <h1>{word['Start_creating_your_project']}</h1>
            <Button
              id="btn_createProject"
              className="BTN_Next"
              onClick={goCreate}
              hidden={permission.create ? false : true}
              disabled={company_user < 1 || company_user === '' ? true : false}
            >
              <PlusOutlined className="Icon-color" />
              {word['Create_Project']}
            </Button>
          </EmptyContainer>
        </Container>
      )
    }
  }
  const handleTabChange = (key) => {
    setActiveTabKey(key)
    localStorage.setItem('activeProjectTab', key)
  }
  return (
    <Container>
      <Helmet>
        <title>AXONS PROJECT | {word['Project_List']}</title>
      </Helmet>
      <Col>
        <div style={{ marginBottom: '24px' }} className="no-breadcrumb">
          {word['Project']}
        </div>
      </Col>
      <Col style={{ marginBottom: '29px' }}>
        <Tabs activeKey={activeTabKey} onChange={handleTabChange}>
          <TabPane
            tab={<span style={{ fontSize: '20px', color: '074E9F' }}>Project Gantt</span>}
            key="1"
          >
            <div ref={ganttRef}>
              <Container className="container-component">
                <Iframe
                  source={`${REACT_APP_URL}/v2/gantt-view`}
                />
              </Container>
            </div>
          </TabPane>
          <TabPane
            tab={<span style={{ fontSize: '20px', color: '074E9F' }}>Project Card</span>}
            key="2"
          >
            <HeaderContent
              onDataReceived={setReceivedData}
              setDataSearch={setDataSearch}
              permission={permission}
              company_user={company_user}
              word={word}
              role={roleUser}
            />
            <div style={{ marginTop: '20px' }}>{showContent()}</div>
          </TabPane>
        </Tabs>
      </Col>
    </Container>
  )
}

export default HomeComponents
